import {ChangeDetectionStrategy, Component, input} from '@angular/core'
import {faFilePdf} from '@fortawesome/pro-regular-svg-icons/faFilePdf'
import {faFileArrowDown} from '@fortawesome/pro-solid-svg-icons/faFileArrowDown'

@Component({
  selector: 'cft-files-summary',
  templateUrl: './files-summary.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class FilesSummaryComponent {
  files = input.required<FileSummary[]>()
  invert = input<boolean>(false)

  readonly pdfIcon = faFilePdf
  readonly otherFileIcon = faFileArrowDown
}

export interface FileSummary {
  fileKey: string
  name?: string
  url: string
  contentType: string
}
